import type { Movimentacao } from '../../api/movimentacoes.js';
import './AutorDaMovimentacao.css';

/** Quem registrou e em que aparelho — o mesmo par na etapa única e na abertura. */
export type Autor = Pick<Movimentacao, 'operador' | 'dispositivo'>;

/**
 * Quem registrou e em que aparelho (RF-072, RF-076).
 *
 * Movimentação sem autor existe — registro antigo, importação — e a tela diz
 * isso em vez de deixar a célula vazia, que se leria como falha de carga.
 */
export function AutorDaMovimentacao({ autor }: { readonly autor: Autor }) {
  const { operador, dispositivo } = autor;

  return (
    <span className="autor-movimentacao">
      <span className="autor-movimentacao__pessoa">
        {operador === null ? 'Sem operador' : `${operador.nome} · ${operador.matricula}`}
      </span>
      <span className="autor-movimentacao__aparelho">
        {dispositivo === null ? 'Sem dispositivo' : dispositivo.identificador}
      </span>
    </span>
  );
}
